export default __webpack_public_path__ + "static/media/src_repairapp_desk_2.1e255ea4.jpg";